import React, { memo, Suspense, useCallback, useEffect } from 'react'
import { ProductsDetail } from '../../../../../../components/v2/product-detail'
import { getOrderDetailData } from '../../../../../../store/ordersDetail/action-creators'
import { clearOrdersDetail } from '../../../../../../store/ordersDetail/actions'
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch/useAppDispatch'
import { refreshOrdersForm } from '../../../../../../store/order/action-creators'
import './index.css'

const ProductsTab = ({id}) => {
  const dispatch = useAppDispatch()
  const entityType = 'case'

  const fetchData = useCallback(() => {
    dispatch(getOrderDetailData(entityType, id))
    if (id && id !== 'new') {
      dispatch(refreshOrdersForm(id))
    }
  }, [entityType, id, dispatch])

  useEffect(() => {
    fetchData()
    return () => {
      dispatch(clearOrdersDetail())
    }
  }, [fetchData, dispatch])

  return (
    <Suspense fallback={''}>
      <ProductsDetail id={id} entityType={entityType} reloadData={fetchData}/>
    </Suspense>
  )
}

export default memo(ProductsTab)
